const kobrosData = {
  name: 'kobros',
  titleText: '¿Cobrar facturas te quita tiempo?',
  subtitleText: 'Con KoBros, tu asesor de cobranza con inteligencia artificial, optimiza la gestión de tus cuentas por cobrar y asegura tus flujos justo cuando los necesitas. ',
  startTextButton: 'Probar koBros gratis',
  hero_image: '/images/kobros_hero.webp',
  description_information: {
    image: '/images/kobros_description.webp',
    title: '¿Qué es KoBros?',
    text: 'KoBros es la herramienta de gestión de cobranza inteligente dentro de la plataforma Fingo, diseñada para ayudarte a organizar, priorizar y ejecutar el seguimiento de tus facturas por cobrar. '
    + 'Utiliza inteligencia artificial para recomendar en qué clientes y facturas enfocarse primero, según riesgo de atraso, comportamiento de pago y montos involucrados. '
    + 'Además, entrega herramientas para enviar recordatorios automáticos facilitando una cobranza más efectiva y oportuna.',
  },
  benefits_information: {
    image: '/images/kobros_benefits.webp',
    title: 'Beneficios de utilizar KoBros',
    text: [
      'Organiza todas tus facturas por cobrar en un solo lugar.',
      'Recibe recomendaciones automáticas para priorizar tu gestión de cobranza.',
      'Envía recordatorios automáticos y personalizados a tus clientes.',
      'Mejora el flujo de caja al reducir atrasos en los pagos.',
      'Ahorra tiempo y esfuerzo con procesos más eficientes y automatizados.',
      'No necesitas conocimientos técnicos ni herramientas externas para comenzar a usarla.',
    ],
  },
  requirements_information: {
    image: '/images/solution_requirements.webp',
    title: 'Requisitos',
    text: [
      'KoBros está disponible para todas las empresas registradas en Fingo que operen con facturas por cobrar.',
      'Para comenzar a usarlo, solo necesitas vincular tu cuenta con el SII, lo que permite sincronizar automáticamente tus facturas emitidas.',
      'No se requiere integración técnica adicional.',
    ],
  },
  demo: {
    stackText: 'CONTACTO',
    title: 'Contáctanos',
    cardTitle: 'Ingresa tus datos para solicitar una demo. ¡Te contactaremos a la brevedad!',
    nameLabel: '¿Cuál es tu nombre?',
    lastNameLabel: 'Apellido',
    phoneNumberLabel: 'Teléfono',
    emailLabel: 'Email',
    questionLabel: 'Mensaje',
    buttonText: 'Solicitar información',
    message: 'Solicitud de demo de KoBros',
  },
};

export default kobrosData;
